import { Col, Create, Form, Input, Row, notification, useForm } from '@pankod/refine-antd';
import { useNavigation } from '@pankod/refine-core';
import { IMeasurementUnit } from 'interfaces';
import { useState } from 'react';
import { createMeasurementUnit } from 'services/measurement-units';

export const MeasurementUnitCreate: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);

  const { form, formProps, saveButtonProps, queryResult } = useForm<IMeasurementUnit>();
  const { push } = useNavigation();

  const onFinish = async (values: any) => {
    try {
      setIsLoading(true);
      await createMeasurementUnit({ ...values, description: values.description ?? null });
      notification.success({
        message: 'Success',
        description: 'Measurement unit created successfully',
      });
      push('/measurement-units');
    } catch (err: any) {
      console.error(err?.message);
      notification.error({
        message: 'Failed',
        description: err?.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Create
      isLoading={queryResult?.isFetching}
      saveButtonProps={{ ...saveButtonProps, disabled: isLoading }}
    >
      <Form
        {...formProps}
        form={form}
        layout="vertical"
        initialValues={{
          isActive: true,
        }}
        onFinish={onFinish}
      >
        <Row justify="space-around" align="middle">
          <Col xs={24} lg={12}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Abbreviation"
              name="abbreviation"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item label="Description" name="description">
              <Input.TextArea rows={3} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Create>
  );
};
